import Cookies from 'universal-cookie'

const cookies = new Cookies(null, { path: '/' })

export const CookieUtils = {
    getAll: () => cookies.getAll(),
    get: (key) => cookies.get(key),
    set: (key, value) => cookies.set(key, value),
    remove: (key) => cookies.remove(key),
}